import { Component,  Input, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { MediaSummaryModel } from '../../models/content-library-media-summary.model';

@Component({
    selector: 'agpr-multiple-item-selection',
    templateUrl: './multiple-item-selection.html',
    styleUrls: ['./multiple-item-selection.scss'],
    standalone: false
})
export class MultipleItemSelectionComponent {
    @Input() currentlySelectedItems: MediaSummaryModel[] = [];
    @Output() itemRemoved = new EventEmitter<MediaSummaryModel>();
    @Output() clearSelectionRequested = new EventEmitter<void>();
    @Output() itemUnselected = new EventEmitter<MediaSummaryModel>();

    clearSelection(): void {
        this.clearSelectionRequested.emit();
    }

    onItemUnselected(item: MediaSummaryModel): void {
        this.itemUnselected.emit(item);
    }

    removeItem(item: MediaSummaryModel): void {
        item.isSelected = false;
        this.itemRemoved.emit(item);
    }
}
